import { Button, Dialog, DialogActions, DialogTitle, IconButton } from "@mui/material";
import { IoClose } from "react-icons/io5";

export default function SkipAlert({open, onClose}) {
  
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="skip-limit-title"
      open={open}
    >
      <DialogTitle id="skip-limit-title">
        You have reached the maximum number of skips allowed for this channel (as per music licensing guidelines) for this hour.
        <IconButton
          aria-label="close"
          color="default"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8
          }}
        >
          <IoClose />
        </IconButton>
      </DialogTitle>
      <DialogActions sx={{p: 2}}>
        <Button color="primary" sx={{maxWidth: "fit-content"}} onClick={() => onClose()}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}
